"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _templateObject = _taggedTemplateLiteral(["\n    width: 100%;\n    overflow: hidden;\n    margin-bottom: ", "em;\n"], ["\n    width: 100%;\n    overflow: hidden;\n    margin-bottom: ", "em;\n"]);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require("styled-components");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Accordion = _styledComponents2.default.div(_templateObject, function (props) {
    return props.theme.tabordion.margin;
});

exports.default = Accordion;


//////////////////
// WEBPACK FOOTER
// ./~/rla-components/dist/components/accordion/accordion.js
// module id = 446
// module chunks = 95715928098905 168707334958949